import httpManager from "@/app/shared/utils/httpManager";

/**
 * @param {Object} body
 */

export async function duplicateChatbot(body) {
  await httpManager.post(`/chatbots/copy/`, body);
}
